// extracted by mini-css-extract-plugin
export default {"button":"SDPWGj6Ukk","secondary":"PdI8rCKNtB","blue":"rUZvFvgYgw","red":"Ac_HMC3ztR","primary":"Ra8QPZTFvN","success":"ReWlR2u0uc","dark":"aW105p6lwW"};